import { memo } from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';

interface StorageNodeData {
  label: string;
  description?: string;
  storageType?: 'database' | 'cache' | 'file' | 's3';
}

const icons: Record<string, string> = {
  database: '🗄️',
  cache: '⚡',
  file: '📁',
  s3: '☁️',
};

export const StorageNode = memo(function StorageNode({
  data,
  selected,
}: NodeProps) {
  const nodeData = data as unknown as StorageNodeData;
  const icon = icons[nodeData.storageType || 'database'] || '🗄️';

  return (
    <div
      className={`px-4 py-3 rounded-lg border-2 bg-green-50 min-w-[150px] ${
        selected ? 'border-primary shadow-lg' : 'border-green-300'
      }`}
    >
      <Handle type="target" position={Position.Top} className="!bg-green-500" />

      <div className="flex items-center gap-2">
        <span className="text-xl">{icon}</span>
        <div>
          <div className="font-semibold text-sm">{nodeData.label}</div>
          {nodeData.description && (
            <div className="text-xs text-muted-foreground mt-1">
              {nodeData.description}
            </div>
          )}
        </div>
      </div>

      <Handle type="source" position={Position.Bottom} className="!bg-green-500" />
    </div>
  );
});
